import React, { useState, useEffect } from 'react';
import './App.css';
import './styles/AdminPages.css';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import FilieresPage from './pages/FilieresPage';
// import VieScolairePage from './pages/VieScolairePage'; // Désactivé - Ne fait plus partie du projet
import ProjetsPage from './pages/ProjetsPage';
import PartenairesPage from './pages/PartenairesPage';
import OpportunitesPage from './pages/OpportunitesPage';
import ActualitesPage from './pages/ActualitesPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import InscriptionPage from './pages/InscriptionPage';
import StudentRegistrationPage from './pages/StudentRegistrationPage';
import PartnerPage from './pages/PartnerPage';
import PortalLoginPage from './pages/PortalLoginPage';
import StudentDashboard from './pages/StudentDashboard';
import StudentNotes from './pages/StudentNotes';
import StudentEmploiDuTemps from './pages/StudentEmploiDuTemps';
import ParentDashboard from './pages/ParentDashboard';
import EmploiDuTemps from './pages/EmploiDuTemps';
import Payement from './pages/Payement';
import Historique from './pages/Historique';
import ContactLycee from './pages/ContactLycee';
import AdminDashboard from './pages/AdminDashboard';
import GestionEleves from './pages/GestionEleves';
import VueEtudiant from './pages/VueEtudiant';
import EnvoyerMailAdmin from './pages/admin/EnvoyerMailAdmin';
import EnvoyerSMSAdmin from './pages/admin/EnvoyerSMSAdmin';
import GestionRessources from './pages/GestionRessources';
import AdminEmploiDuTemps from './pages/AdminEmploiDuTemps';
import GestionEnseignants from './pages/GestionEnseignants';
import GestionOpportunites from './pages/admin/GestionOpportunites';
import GestionFilieres from './pages/admin/GestionFilieres';
import GestionClubs from './pages/admin/GestionClubs';
import GestionProjets from './pages/admin/GestionProjets';
import GestionPartenaires from './pages/admin/GestionPartenaires';
import GestionActualites from './pages/admin/GestionActualites';
import GestionMessages from './pages/admin/GestionMessages';
import GestionStages from './pages/admin/GestionStages';
import GestionBourses from './pages/admin/GestionBourses';
import GestionBulletins from './pages/admin/GestionBulletins';
import DuplicataBulletins from './pages/admin/DuplicataBulletins';
import GestionSignalements from './pages/admin/GestionSignalements';
import RapportsAbsences from './pages/admin/RapportsAbsences';
import GestionAbsencesRetards from './pages/admin/GestionAbsencesRetards';
import HistoriquePaiements from './pages/admin/HistoriquePaiements';
import NouvellesInscriptions from './pages/admin/NouvellesInscriptions';
import GestionClasses from './pages/admin/GestionClasses';
import GestionElevesClasse from './pages/admin/GestionElevesClasse';
import SupportAdmin from './pages/admin/SupportAdmin';
import TeacherDashboard from './pages/TeacherDashboard';
import TeacherAbsences from './pages/TeacherAbsences';
import TeacherNotes from './pages/TeacherNotes';
import TeacherClasses from './pages/TeacherClasses';
import TeacherMessages from './pages/TeacherMessages';
import TeacherSettings from './pages/TeacherSettings';
import AdminValidationNotes from './pages/AdminValidationNotes';
import AttributionClasses from './pages/AttributionClasses';
import DonationPage from './pages/DonationPage';
import ActualiteDetailPage from './pages/ActualiteDetailPage';
import OpportuniteDetailPage from './pages/OpportuniteDetailPage';
import DocumentsUtilesPage from './pages/DocumentsUtilesPage';
import GestionFournitures from './pages/admin/GestionFournitures';
import GestionAdministrateurs from './pages/admin/GestionAdministrateurs';
import BrochurePopup from './components/BrochurePopup';

const getPageFromUrl = () => {
  if (typeof window === 'undefined') return 'home';
  const pathname = window.location.pathname.replace(/^\/+|\/+$/g, '');
  const hash = window.location.hash.replace(/^#+/, '').replace(/^\/+|\/+$/g, '');
  const rawPath = pathname || hash;
  
  if (rawPath) {
    // Alias pour Fournitures & Documents
    if (rawPath === 'documents-utiles' || rawPath === 'fournitures' || rawPath === 'fournitures-et-horaires' || rawPath === 'fournitures-scolaires') {
      return 'documents-utiles';
    }
    if (rawPath === 'admin/fournitures' || rawPath === 'gestion-fournitures') {
      return 'gestion-fournitures';
    }
    return rawPath;
  }
  return localStorage.getItem('currentPage') || 'home';
};

function App() {
  const [currentPage, setCurrentPage] = useState(getPageFromUrl);
  const [pageData, setPageData] = useState(null);
  const [navigationHistory, setNavigationHistory] = useState([getPageFromUrl()]);

  const navigateTo = (page, data = null) => {
    setCurrentPage(page);
    setPageData(data);
    setNavigationHistory(prev => [...prev, page]);
    localStorage.setItem('currentPage', page);

    // Mettre à jour l'URL dans la barre d'adresse du navigateur sans rechargement
    if (typeof window !== 'undefined') {
      const targetUrl = page === 'home' ? '/' : `/${page}`;
      if (window.location.pathname !== targetUrl) {
        window.history.pushState({ page, data }, '', targetUrl);
      }
    }
  };

  const goBack = () => {
    if (navigationHistory.length > 1) {
      const newHistory = navigationHistory.slice(0, -1);
      setNavigationHistory(newHistory);
      const previousPage = newHistory[newHistory.length - 1];
      setCurrentPage(previousPage);
      localStorage.setItem('currentPage', previousPage);

      if (typeof window !== 'undefined') {
        const targetUrl = previousPage === 'home' ? '/' : `/${previousPage}`;
        window.history.pushState({ page: previousPage }, '', targetUrl);
      }
    }
  };

  // Écoute des événements de retour/suivant du navigateur (popstate)
  useEffect(() => {
    const handlePopState = () => {
      const page = getPageFromUrl();
      setCurrentPage(page);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Rendre les fonctions de navigation accessibles globalement
  useEffect(() => {
    window.navigateTo = (page, data = null) => {
      navigateTo(page, data);
    };
    window.goBack = goBack;
    window.getCurrentPage = () => currentPage;
  }, [currentPage]);

  // Simple routing system
  const renderPage = () => {
    switch(currentPage) {
      case 'about':
        return <AboutPage />;
      case 'filieres':
        return <FilieresPage />;
      // case 'vie-scolaire':
      //   return <VieScolairePage />; // Désactivé - Ne fait plus partie du projet
      case 'projets':
        return <ProjetsPage />;
      case 'partenaires':
        return <PartenairesPage />;
      case 'opportunites':
        return <OpportunitesPage />;
      case 'actualites':
        return <ActualitesPage />;
      case 'contact':
        return <ContactPage />;
      case 'login':
        return <LoginPage />;
      case 'inscription':
        return <InscriptionPage />;
      case 'student-registration':
        return <StudentRegistrationPage />;
      case 'partner':
        return <PartnerPage />;
      case 'portal-login-parent':
        return <PortalLoginPage portalType="Portail Parent" />;
      case 'portal-login-student':
        return <PortalLoginPage portalType="Portail Étudiant" />;
      case 'portal-login-family':
        return <PortalLoginPage portalType="Portail Parents/Élèves" />;
      case 'portal-login-admin':
        return <PortalLoginPage portalType="Portail Administration" />;
      case 'portal-login-teacher':
        return <PortalLoginPage portalType="Portail Professeur" />;
      case 'parent-dashboard':
        return <ParentDashboard />;
      case 'student-dashboard':
        return <StudentDashboard />;
      case 'student-notes':
        return <StudentNotes />;
      case 'student-emploi-du-temps':
        return <StudentEmploiDuTemps />;
      case 'emploi-du-temps':
        return <EmploiDuTemps />;
      case 'payement':
        return <Payement />;
      case 'historique':
        return <Historique />;
      case 'contact-lycee':
        return <ContactLycee />;
      case 'admin-dashboard':
        return <AdminDashboard />;
      case 'gestion-eleves':
        return <GestionEleves />;
      case 'vue-etudiant':
        return <VueEtudiant />;
      case 'admin-envoyer-mail':
        return <EnvoyerMailAdmin />;
      case 'admin-envoyer-sms':
        return <EnvoyerSMSAdmin />;
      case 'gestion-ressources':
        return <GestionRessources />;
      case 'admin-emploi-du-temps':
        return <AdminEmploiDuTemps />;
      case 'gestion-enseignants':
        return <GestionEnseignants />;
      case 'gestion-opportunites':
        return <GestionOpportunites />;
      case 'gestion-filieres':
        return <GestionFilieres />;
      case 'gestion-clubs':
        return <GestionClubs />;
      case 'gestion-projets':
        return <GestionProjets />;
      case 'gestion-partenaires':
        return <GestionPartenaires />;
      case 'gestion-actualites':
        return <GestionActualites />;
      case 'gestion-messages':
        return <GestionMessages />;
      case 'gestion-stages':
        return <GestionStages />;
      case 'gestion-bourses':
        return <GestionBourses />;
      case 'gestion-bulletins':
        return <GestionBulletins />;
      case 'duplicata-bulletins':
        return <DuplicataBulletins />;
      case 'gestion-signalements':
        return <GestionSignalements />;
      case 'rapports-absences':
        return <RapportsAbsences />;
      case 'gestion-absences-retards':
        return <GestionAbsencesRetards />;
      case 'historique-paiements':
        return <HistoriquePaiements />;
      case 'nouvelles-inscriptions':
        return <NouvellesInscriptions />;
      case 'gestion-classes':
        return <GestionClasses />;
      case 'gestion-eleves-classe':
        return <GestionElevesClasse />;
      case 'support':
        return <SupportAdmin />;
      case 'teacher-dashboard':
        return <TeacherDashboard />;
      case 'teacher-absences':
        return <TeacherAbsences />;
      case 'teacher-notes':
        return <TeacherNotes />;
      case 'teacher-classes':
        return <TeacherClasses />;
      case 'teacher-messages':
        return <TeacherMessages />;
      case 'teacher-settings':
        return <TeacherSettings />;
      case 'validation-notes':
        return <AdminValidationNotes />;
      case 'attribution-classes':
        return <AttributionClasses />;
      case 'donation':
        return <DonationPage />;
      case 'actualite-detail':
        return <ActualiteDetailPage slug={pageData} />;
      case 'opportunite-detail':
        return <OpportuniteDetailPage slug={pageData} />;
      case 'documents-utiles':
      case 'fournitures':
      case 'fournitures-et-horaires':
        return <DocumentsUtilesPage />;
      case 'gestion-fournitures':
        return <GestionFournitures />;
      case 'gestion-administrateurs':
        return <GestionAdministrateurs />;
      case 'gestion-contenu':
        return <GestionActualites />; // Redirection vers gestion actualités comme page principale de contenu
      case 'home':
      default:
        return <HomePage />;
    }
  };

  // Vérifier si on est sur une page publique (pas un dashboard)
  const isPublicPage = !currentPage.includes('dashboard') && 
                       !currentPage.includes('admin') && 
                       !currentPage.includes('teacher') && 
                       !currentPage.includes('student') && 
                       !currentPage.includes('parent') &&
                       !currentPage.includes('gestion') &&
                       !currentPage.includes('validation') &&
                       !currentPage.includes('emploi-du-temps') &&
                       !currentPage.includes('payement') &&
                       !currentPage.includes('historique') &&
                       !currentPage.includes('contact-lycee') &&
                       !currentPage.includes('vue-etudiant') &&
                       !currentPage.includes('support') &&
                       !currentPage.includes('nouvelles-inscriptions');

  return (
    <div className="App">
      {renderPage()}
      {isPublicPage && <BrochurePopup />}
    </div>
  );
}

export default App;
